import { createFileRoute } from "@tanstack/react-router";
import DistributionTransportation from "@/pages/services/DistributionTransportation";

export const Route = createFileRoute("/services/distribution-transportation")({
  component: DistributionTransportation,
});